module.exports = __webpack_public_path__ + "static/placeholderEN-2f6595f332b3abcbf927911cdf2b0173.jpg";